// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2i53Z","alert":"SettungsInbox_alert__3qgg7"};